import { Media } from "./media";

export class Noticias {

    constructor(item: Noticias | void) {
        if(item instanceof Object) {
            this.id = item.id;
            this.titulo = item.titulo;
            this.body = item.body;
            this.media = item.media;
            this.activo = item.activo;
            this.loginId = item.loginId;
            this.subtitulo = item.subtitulo;
            this.created = new Date(item.created);
        }
    }

    id: number = -1;
    titulo: string = "";
    body: string = "";
    media: string = "";
    activo: boolean = true;
    loginId: number = -1;
    subtitulo: string = "";
    created: Date = new Date();
}

export class NoticiasSend {

    constructor(item: NoticiasSend | void) {
        if(item instanceof Object) {
            this.id = item.id;
            this.titulo = item.titulo;
            this.body = item.body;
            this.media = item.media;
            this.activo = item.activo;
            this.subtitulo = item.subtitulo;
            this.userId = item.userId;
        }
    }

    id: number = -1;
    titulo: string = "";
    body: string = "";
    media: Media[] = [];
    activo: boolean = true;
    subtitulo: string = "";
    userId: string;
}
